export default __webpack_public_path__ + "static/media/Sunset-Turbines-Narrow-1920px-720px.jpg.c541ca04.webp";